import {Injectable} from '@angular/core';
import {UserProfile} from './model/user-profile';
import {HttpClientService} from './http-client.service';
import {Observable, of} from 'rxjs';
import {UserResponseData} from "./model/user-response-data";
import {NewPassword} from "./model/new-password";
import {map, shareReplay, tap} from 'rxjs/operators';
import {HttpErrorResponse} from "@angular/common/http";
import {CoreService} from "./core.service";

declare let iNet: any;
const AVATAR_VERSION_KEY = 'avatarVersion';

@Injectable({
    providedIn: 'platform'
})
export class UserProfileService {
    static instance: UserProfileService = null;
    static readonly DEFAULT_AVATAR_URL = 'data:image/jpeg;base64,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';
    private $cache: Observable<Object>;
    private profile: UserProfile = null;

    private $systemProfileCache: Observable<Object>;
    private systemProfile: UserResponseData = null;

    private $profileObservableCache: any = {};
    private inventory: any = {};

    private url = {
        get: iNet.getPUrl('gl/contact/load'),
        view: iNet.getPUrl('system/userprofile/view'),
        update: iNet.getPUrl('system/userprofile/update'),
        change_password: iNet.getPUrl('system/account/passsword'),
        photo: iNet.getPUrl('system/userprofile/photo')
    };

    constructor(private http: HttpClientService,
                private coreService: CoreService) {
    }

    /*
    private loadProfile(): Observable<Object> {
        return this.http.postJSON(this.url.get)
            .map((res: UserProfile) => res)
            .do(profile => this.profile = profile);
    }
     */

    private loadSystemProfile(): Observable<Object> {
        return this.http.postJSON(this.url.view).pipe(
            map((res: UserResponseData) => res),
            tap((profile: any) => {
                this.systemProfile = profile;
                this.profile = profile.user as UserProfile;
            })
        );
    }

    /**
     * Gets the currently LDAP profile of user logged
     */
    getSystemProfile(): Observable<Object> {
        if (this.systemProfile) {
            return of(this.systemProfile);
        }
        if (!this.$systemProfileCache) {
            this.$systemProfileCache = this.loadSystemProfile().pipe(shareReplay(1));
        }
        return this.$systemProfileCache;
    }

    /**
     * Gets the currently profile of user logged
     */
    getProfile(): Observable<Object> {
        if (this.profile) {
            return of(this.profile);
        }
        return this.getSystemProfile().pipe(map((res: UserResponseData) => res.user));
    }

    update(user: UserProfile): Observable<Object> {
        this.$cache = null;
        return this.http.postJSON(this.url.update, user);
    }

    changePassword(password: NewPassword): Observable<Object> {
        return this.http.postJSON(this.url.change_password, password);
    }

    getAvatarUrlByProfile(userProfile: UserProfile): string {
        let avatarUrl: string;
        avatarUrl = this.coreService.getFileUrl(userProfile.avatar);
        if (this.getAvatarVersion() > 0) {
            avatarUrl = `${avatarUrl}?version=${this.getAvatarVersion()}`;
        }
        return avatarUrl;
    }

    getAvatarUrl(): Promise<string> {
        return new Promise(resolve => {
            resolve(this.url.photo);
            /*
            this.getProfile().subscribe((obj: UserProfile) => {
                // resolve(this.getAvatarUrlByProfile(obj));
            }, (err: HttpErrorResponse) => {
                resolve();
            });

             */
        });
    }

    getFullName(): Promise<string> {
        return new Promise(resolve => {
            if (!window['iNet'] || iNet.isEmpty(iNet.prefix) || !iNet.enableLayout) {
                resolve(window['iNet'] ? iNet.displayName : '');
            } else {
                this.getProfile().subscribe((profile: UserProfile) => {
                    let fullName: string = '';
                    if (profile.lastName) {
                        fullName += profile.lastName;
                    }
                    if (profile.middleName) {
                        fullName += ' ' + profile.middleName;
                    }
                    if (profile.firstName) {
                        fullName += ' ' + profile.firstName;
                    }
                    profile.name = fullName || iNet.displayName || iNet.username;
                    resolve(profile.name.trim());
                }, (err: HttpErrorResponse) => {
                    resolve('');
                });
            }
        });
    }

    getSignPictureId(): Promise<string> {
        return new Promise(resolve => {
            this.getSystemProfile().subscribe((data: UserResponseData) => {
                let signPictureId: string = '';
                if (data.user && data.user.signPictureID) {
                    signPictureId = data.user.signPictureID;
                }
                resolve(signPictureId);
            }, (err: HttpErrorResponse) => {
                resolve('');
            });
        });
    }

    getSignVerifyNumber(): Promise<string> {
        return new Promise(resolve => {
            this.getSystemProfile().subscribe((data: UserResponseData) => {
                let signVerify: string = '';
                if (data.user && data.user.signVerify) {
                    signVerify = data.user.signVerify;
                }
                resolve(signVerify);
            }, (err: HttpErrorResponse) => {
                resolve('');
            });
        });
    }

    increaseAvatarVersion() {
        localStorage.setItem(AVATAR_VERSION_KEY, (this.getAvatarVersion() + 1).toString());
    }

    getAvatarVersion(): number {
        return Number(localStorage.getItem(AVATAR_VERSION_KEY));
    }

    /**
     * Returns the profile associated with the username.
     * @param username - {string} The username variable
     */
    getProfileByUsername(username: string): Observable<any> {
        //console.log('[getProfileByUsername]--username, inventory', username, this.inventory);
        if (this.inventory.hasOwnProperty(username)) {
            return of(this.inventory[username]);
        }
        if (!this.$profileObservableCache[username]) {
            this.$profileObservableCache[username] = this.http.getJSON(this.url.get, {username: username})
                .pipe(tap((res) => this.inventory[username] = res), shareReplay(1))
        }
        return this.$profileObservableCache[username];
    }

    /**
     * Returns the avatar URL  with the username.
     * @param username - {string} The username variable
     */
    getAvatarUrlByUsername(username: string): Promise<string> {
        return new Promise(resolve => {
            this.getProfileByUsername(username).subscribe((obj: UserProfile) => {
                if (obj.avatar) {
                    resolve(this.coreService.getFileUrl(obj.avatar));
                } else {
                    resolve('');
                }
            }, (err: HttpErrorResponse) => {
                resolve('');
            });
        });
    }

    getDefaultAvatarUrl(): string {
        return UserProfileService.DEFAULT_AVATAR_URL;
    }
}
